import { IntegrationConnectionsEnum } from "@models/integrations/integration-connections.enum";
import { ConnectionStatusEnum } from "@models/integrations/connection-status.enum";
import { SyncStatusEnum } from "@models/integrations/sync-status.enum";
import { IConnection, IConnectionButton } from "../integration.view.model";

export function getXpmConnectionItem(actions: IConnectionButton[] = []): IConnection {
  return {
    title: 'Xero Practice Manager',
    description: 'Connect your Xero Practice Manager to your Pravo account for efficient client data management.',
    lastSync: '',
    syncStatus: SyncStatusEnum.NotSynced,
    connectionStatus: ConnectionStatusEnum.NotConnected,
    connectionType: IntegrationConnectionsEnum.XpmConnection,
    image: 'assets/images/xero-practice-manager.svg',
    isLoading: true,
    buttons: actions
  };
}

export function getAnnatureConnectionItem(actions: IConnectionButton[] = []): IConnection {
  return {
    title: 'Annature',
    description: 'Annature is Australia\'s favorite eSignature solution. Link your Annature account to your Pravo account to start seamlessly sending your documents for quick and secure online signatures.Connect your Annature account to use your esign account(test)',
    connectionStatus: ConnectionStatusEnum.NotConnected,
    connectionType: IntegrationConnectionsEnum.AnnatureConnection,
    image: 'assets/images/annature-logo.svg',
    isLoading: true,
    buttons: actions
  };
}

export function getDocuSignConnectionItem(actions: IConnectionButton[] = [] = []): IConnection {
  return {
    title: 'DocuSign',
    description: 'Link your Docusign account with your Pravo account and enjoy the convenience of sending documents for online signing.',
    connectionStatus: ConnectionStatusEnum.NotConnected,
    connectionType: IntegrationConnectionsEnum.DocuSignConnection,
    image: 'assets/images/docusign-logo.svg',
    isLoading: true,
    buttons: actions,
  };
}
